module.exports = __webpack_public_path__ + "img/Headset.9784e0f4.svg";